import { setUser } from '.';
import { resolveUser } from '../../services/user';
import { resolveUserRole } from '../../services/userRole';
import { TUser } from '../../types/currentUser';
import { TThunkAction } from '../../types/redux/thunk';
import { setUserRole } from '../userRole';

export function getUserAction(): TThunkAction<Promise<TUser>> {
  return async (dispatch, getState, context) => {
    const { httpApi, logger, config } = context;
    const state = getState();
    const [user, userRole] = await Promise.all([
      resolveUser({ config, httpApi, logger, subdomain: state.subdomain }),
      resolveUserRole({ config, httpApi, logger }),
    ]);
    dispatch(setUser(user));
    dispatch(setUserRole(userRole));

    return user;
  };
}
